module.exports = __webpack_public_path__ + "img/undraw_events.c860b582.svg";